export default {
    validation: {
        eircodeRequired: 'Please enter your eircode.',
        addressLine1Required: 'Please enter your address.',
        addressSelectRequired: 'Please select your address.',
        
    },
    errormessage: {
        noAddressFoundforEirCode: 'No address found',
        addressFinderNetworkError: 'Network error. Please try later.',
        eircodeNotConfirmed: 'Please confirm eircode.',
    },
};